import axios from "axios";
import {
  AlreadyBookedPitch,
  CreateCustomer,
  CreateOrder,
  Customer,
  Holidays,
  ItemDetails,
  MaintenanceIframe,
  venueListingPage,
  CouponCode,
  GetCountryTime,
} from "../common/api";

export const handleCreateOrder = async (payload, token) => {

  try {
    const response = await axios.post(
      CreateOrder,
      {
        cart_data: payload,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to create order");
    }
  } catch (error) {
    throw new Error("Error creating order:", error);
  }
};

export const handleGetProductDetails = async (payload) => {
  try {
    const response = await axios.post(ItemDetails, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getAlreaduBookedPitches = async (payload) => {
  try {
    const response = await axios.post(AlreadyBookedPitch, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};
export const getCountrytime = async (payload) => {
  try {
    const response = await axios.post(GetCountryTime, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};
export const createMaintanenceBooking = async (payload) => {
  try {
    const response = await axios.post(
      MaintenanceIframe,

      payload,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to create order");
    }
  } catch (error) {
    throw new Error("Error creating order:", error);
  }
};

export const getHolidaylist = async (payload) => {
  try {
    const response = await axios.post(Holidays, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getCustomerlist = async (searchTerm = "") => {
  console.log("Customer in get customerlist", Customer);
  const token = localStorage.getItem("token");
  
  try {
    // Pass search term as query parameter
    const url = searchTerm ? `${Customer}?search=${encodeURIComponent(searchTerm)}` : Customer;
    
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get customer details");
    }
  } catch (error) {
    throw new Error("Error getting customer details", error);
  }
};

export const createCustomer = async (payload) => {
  try {
    const response = await axios.post(CreateCustomer, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get customer details");
    }
  } catch (error) {
    throw new Error("Error getiing customer details", error);
  }
};

export const getPitchData = async (payload) => {
  try {
    const response = await axios.get(venueListingPage + "/" + payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const validateCouponCode = async (Coupon, Amount, Quantity, bookingFor) => {
 
  const token = localStorage.getItem("token");
  // console.log("Token in validateCouponCode", token);
  
  try {
    const response = await axios.get(CouponCode, {
      params: {
        amount: Amount,
        quantity: Quantity, 
        coupon_name: Coupon,
        booking_for: bookingFor,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },

    });



    console.log( "response for coupon",response);

    if (response.status === 200) {
      console.log(response.data, "response for coupon");
      
      return response;
    } else {
      throw new Error(response.data?.message?.message || "Failed to apply coupon");
    }
  } catch (error) {
    throw error;
  }
};
